<template>
  <div class='container-header wrapHeader'>
    <div class='wareTitle'>仓房列表</div>
    <div class='warpTitle log'>{{wareName}} {{log}}</div>
    <backBtn></backBtn>
  </div>
</template>

<script>
import backBtn from './back'
export default {
  components:{
    backBtn
  },
  props:['wareName','log']
}
</script>

<style>
  .container-header{
    font-size: 18px;
    font-family: '楷体';
    font-weight: bold;
    padding: 0 !important
  }
  .wareTitle{
    height:45px;
    line-height: 45px;
    width: 210px;
    border-right: 5px solid #f0f4f7;
    padding-left: 20px;
    text-align: start;
    box-sizing: border-box;
  }
  .warpTitle{
    padding-left: 20px;
    color: rgba(0, 0, 0, 0.8);
    font-family: 'xingshu';
    font-size: 20px;
    font-weight: 400
  }
</style>